import { defineComponent, useTemplateRef, ref, watch, openBlock, createElementBlock, Fragment, createElementVNode, createTextVNode, toDisplayString, createVNode, unref, withCtx, createBlock, toRaw } from 'vue';
import _sfc_main$1 from '../../../component/dialog/dialog.vue.js';
import '@ssml-editor/core';
import '@ssml-editor/vue';
import { ElIcon, ElButton } from 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                                   */
/* empty css                                                     */
import '@ssml-editor/modules';
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                     */
import { CircleCloseFilled } from '@element-plus/icons-vue';
import BgmContent from './bgm-content.js';
import { BgmContentData } from './data.js';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "bgm-container",
  props: {
    bgmPageSize: {},
    bgmCategoryPageSize: {},
    fetchBgms: { type: Function },
    fetchCategories: { type: Function },
    searchBgms: { type: Function },
    music: {},
    musicName: {}
  },
  setup(__props, { expose: __expose }) {
    const bgmContentRef = useTemplateRef("bgm-content");
    const dialogVisible = ref(false);
    const bgmUsageData = ref({});
    const bgmContentData = ref(new BgmContentData());
    function show() {
      dialogVisible.value = true;
    }
    function hide() {
      dialogVisible.value = false;
    }
    function removeHandler() {
      bgmUsageData.value = {};
    }
    async function submitHandler() {
      bgmUsageData.value = bgmContentRef.value?.getData() || {};
      hide();
    }
    function getData() {
      return toRaw(bgmUsageData.value);
    }
    watch(
      () => __props.music,
      (newValue) => {
        bgmUsageData.value.music = newValue;
      },
      {
        immediate: true
      }
    );
    watch(
      () => __props.musicName,
      (newValue) => {
        bgmUsageData.value.musicName = newValue;
      },
      {
        immediate: true
      }
    );
    __expose({
      getData
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", { class: "se-bgm-container" }, [
          bgmUsageData.value?.music && bgmUsageData.value?.musicName ? (openBlock(), createElementBlock("span", {
            key: 0,
            class: "se-music-name"
          }, [
            createTextVNode(toDisplayString(bgmUsageData.value?.musicName) + " ", 1),
            createVNode(unref(ElIcon), {
              class: "se-remove-icon",
              onClick: removeHandler
            }, {
              default: withCtx(() => [
                createVNode(unref(CircleCloseFilled))
              ]),
              _: 1
            })
          ])) : (openBlock(), createBlock(unref(ElButton), {
            key: 1,
            onClick: show,
            type: "primary",
            size: "small",
            plain: ""
          }, {
            default: withCtx(() => [
              createTextVNode("选择")
            ]),
            _: 1
          }))
        ]),
        createVNode(unref(_sfc_main$1), {
          title: "背景音乐",
          width: "calc(var(--el-dialog-padding-primary) * 2 + 12.5rem)",
          modal: true,
          "append-to-body": true,
          "destroy-on-close": true,
          modelValue: dialogVisible.value,
          "onUpdate:modelValue": ($event) => dialogVisible.value = $event,
          onSubmit: submitHandler
        }, {
          default: withCtx(() => [
            createVNode(BgmContent, {
              ref: "bgm-content",
              modelValue: bgmContentData.value,
              "onUpdate:modelValue": ($event) => bgmContentData.value = $event,
              "bgm-category-page-size": __props.bgmCategoryPageSize,
              "bgm-page-size": __props.bgmPageSize,
              "fetch-bgms": __props.fetchBgms,
              "fetch-categories": __props.fetchCategories,
              "search-bgms": __props.searchBgms
            }, null, 8, ["modelValue", "onUpdate:modelValue", "bgm-category-page-size", "bgm-page-size", "fetch-bgms", "fetch-categories", "search-bgms"])
          ]),
          _: 1
        }, 8, ["modelValue", "onUpdate:modelValue"])
      ], 64);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=bgm-container.vue2.js.map
